module.exports = __webpack_public_path__ + "static/media/image-2.e55beb80.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RouteFinder/image-2.png
// module id = 268
// module chunks = 0